import { l } from '@manychat/manyui'

import { UpgradeSource } from 'common/billing'
import { handleGoProError } from 'common/billing/helpers/handleGoProError'
import { alert } from 'common/core'
import { settingsApi } from 'shared/api/requests/settings'
import {
  PersonaApiType,
  SetPersonaApiDataType,
  UploadPersonaApiAvatarPayload,
  UploadPersonaApiAvatarResponse,
} from 'shared/api/requests/settings/schemas'
import { createAsyncAction } from 'shared/lib/redux'

export const usePersona = createAsyncAction(
  'settings/usePersona',
  async (use_persona: boolean) => {
    const response = await settingsApi.persona.usePersona({ body: { use_persona } })

    return response.data
  },
  {
    onBusinessError: (error, _, { dispatch }) => {
      if (settingsApi.persona.usePersona.isGoProError(error)) {
        error.handle()
        dispatch(
          handleGoProError(error, {
            modalTitle: l.translate(`Unlock the ability with Manychat Pro`),
            source: UpgradeSource.SETTINGS,
            products: error.error_data.products,
            message: l.translate(
              "You aren't able to activate this feature on the current plan. Upgrade for unlimited access.",
            ),
          }),
        )
      }
    },
  },
)

export const setPersonaApiData = createAsyncAction(
  'settings/setPersonaApiData',
  async (payload: SetPersonaApiDataType): Promise<PersonaApiType> => {
    const response = await settingsApi.persona.setPersonaApiData({
      body: {
        persona_api_avatar_data: {
          original_avatar_url: payload.persona_api_avatar_data.original_avatar_url,
          resize_avatar_url: payload.persona_api_avatar_data.resize_avatar_url,
          avatar_resize_coordinates: payload.persona_api_avatar_data.avatar_resize_coordinates,
        },
        persona_api_name: payload.persona_api_name,
      },
    })

    alert(l.translate('LiveChat settings are saved'), 'success')
    return response.data
  },
  {
    onBusinessError: (error) => alert(error, 'danger'),
  },
)

export const uploadMultiple = createAsyncAction(
  'settings/uploadMultiple',
  async (payload: UploadPersonaApiAvatarPayload): Promise<UploadPersonaApiAvatarResponse> => {
    const formData = new FormData()
    for (const item of payload) {
      formData.append(item.uploadType, item.blob)
    }

    const response = await settingsApi.persona.uploadMultiple({
      body: formData,
    })

    return response.data
  },
)
